<template lang="pug">

</template>

<script>
import  { mapActions } from 'vuex'
export default {
  name: "SignOut",
  data: () => ({
  }),
  mounted () {
    try {
      this.$store.commit('user/setUser', null)
      this.$store.commit('user/setMember', null)
      this.updateCompany(null)
      localStorage.removeItem('yz_customer_fields')
      localStorage.removeItem('yz_donor_fields')
      localStorage.removeItem('yz_patient_fields')
      localStorage.removeItem('yz_appointment_fields')
    } catch {
      // 
    }
    if (this.$subdomain) {
      document.location.href = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signin`
    } else {
      this.$router.push('/signin')
    }
  },
  methods: {
    ...mapActions([
      'updateCompany'
    ])
  }
}
</script>

<style lang="scss" scoped>

</style>